import { Injectable } from "@angular/core";
import { ObservableBackendService } from "./observableBackend.service";
import { ClientDocument } from "../domain/clientDocument";
import { Observable } from "rxjs/Rx";

/**
 * .
 * Created by jlado on 16/9/16.
 */
@Injectable()
export class ClientDocumentService {

    constructor( private backendService: ObservableBackendService ) {
    }

    public getClientDocuments(): Observable<ClientDocument[]> {
        return this.backendService.get( "clientDocuments", null );
    }

    public save( clientDocument: ClientDocument ): Observable<ClientDocument> {
        return this.backendService.put( "clientDocument/upload", clientDocument, null );
    }

    public saveAll( clientDocument: ClientDocument[] ): Observable<ClientDocument[]> {
        return this.backendService.post( "clientDocuments", clientDocument, null );
    }


    public updateClientDocuments(clientDocument : ClientDocument[]): Observable<ClientDocument[]> {
        return this.backendService.post( "updateClientDocuments", clientDocument, null);
    }
    
    public saveKmAll( clientDocument: ClientDocument[] ): Observable<ClientDocument[]> {
        return this.backendService.post( "clientKmDocuments", clientDocument, null );
    }
    public saveProcedureAll( clientDocument: ClientDocument[] ): Observable<ClientDocument[]> {
        return this.backendService.post( "clientProcedureDocuments", clientDocument, null );
    }
    public savePatentAll( clientDocument: ClientDocument[] ): Observable<ClientDocument[]> {
        return this.backendService.post( "clientPatentDocuments", clientDocument, null );
    }


    public saveKm( clientDocument: ClientDocument ): Observable<ClientDocument> {
        return this.backendService.put( "clientKmDocument/upload", clientDocument, null );
    }
    public savePatent( clientDocument: ClientDocument ): Observable<ClientDocument> {
        return this.backendService.put( "clientPatentDocument/upload", clientDocument, null );
    }
    public saveProcedure( clientDocument: ClientDocument ): Observable<ClientDocument> {
        return this.backendService.put( "clientProcedureDocument/upload", clientDocument, null );
    }

    public getClientKmDocuments(): Observable<ClientDocument[]> {
        return this.backendService.get( "clientKmDocuments", null );
    }

    public getClientProcedureDocuments(): Observable<ClientDocument[]> {
        return this.backendService.get( "clientProcedureDocuments", null );
    }

    public getClientPatentDocuments(): Observable<ClientDocument[]> {
        return this.backendService.get( "clientPatentDocuments", null );
    }

    public delete( clientDocumentId: string ): Observable<ClientDocument> {
        return this.backendService.delete( "clientDocument/" + clientDocumentId, null, null );
    }
    
    
    public getClientDocumentsByBank(bankId: string): Observable<ClientDocument[]> {
        return this.backendService.post( "clientDocumentsByBank",bankId, null );
    }

    public getClientKmDocumentsByBank(bankId: string): Observable<ClientDocument[]> {
        return this.backendService.post( "clientKmDocumentsByBank",bankId, null );
    }

    public getClientProcedureDocumentsByBank(bankId: string): Observable<ClientDocument[]> {
        return this.backendService.post( "clientProcedureDocumentsByBank",bankId, null );
    }

    public getClientPatentDocumentsByBank(bankId: string): Observable<ClientDocument[]> {
        return this.backendService.post( "clientPatentDocumentsByBank",bankId, null );
    }

    
}


/** WEBPACK FOOTER **
 ** ./src/app/service/clientDocument.service.ts
 **/